import { Component, h, Prop, State } from "@stencil/core";
import { MemberPerformanceSummaryViewModel, ShooterInformationCenterClient, ShooterInformationCenterMemberInfoViewModel } from "../../services/services";

@Component({
    tag: "ata-shooter-information-center",
    styleUrl: "ata-shooter-information-center.scss",
    shadow: true
})
export class AtaShooterInformationCenter {

    /** The ID of the current module. */
    @Prop() moduleId: number;

    @State() memberInfo: ShooterInformationCenterMemberInfoViewModel = undefined;
    @State() statsSummary: MemberPerformanceSummaryViewModel[];

    private readonly shooterInformationCenterClient: ShooterInformationCenterClient;
    private searchTab: HTMLDnnTabElement;

    constructor(){
        this.shooterInformationCenterClient = new ShooterInformationCenterClient({moduleId: this.moduleId});
    }

    componentWillLoad() {
        this.shooterInformationCenterClient.getMemberInfo(undefined, undefined)
        .then(data => {
            this.memberInfo = data;
            if (this.memberInfo == undefined) {
                this.searchTab.show();
            }

            if (this.memberInfo && this.memberInfo.ataNumber.length > 0) {
                this.shooterInformationCenterClient.getMemberStatsSummary(this.memberInfo.ataNumber)
                .then(data => {
                    this.statsSummary = data;
                })
                .catch(error => alert(error));
            }
        })
         
        .catch(error => console.error(error));
    }

    render() {
        return (
            <div class="ata-shooter-information-center">
                <h1>Shooter Information Center</h1>
                <dnn-tabs>
                    <dnn-tab tabTitle="My Scores">
                        {(this.memberInfo == undefined || this.memberInfo.ataNumber == null) &&
                            <p>Please login to see your scores.</p>
                        }
                        {this.memberInfo && this.memberInfo.ataNumber &&
                            <ata-sic-scores
                                memberInfo={this.memberInfo}
                                statsSummary={this.statsSummary}
                                moduleId={this.moduleId}
                            />
                        }
                    </dnn-tab>
                    <dnn-tab tabTitle="Search/Buddies" ref={el => this.searchTab = el}>
                        <ata-sic-buddies
                            moduleId={this.moduleId}
                            loggedIn={this.memberInfo != undefined && this.memberInfo.ataNumber != null}
                        />
                    </dnn-tab>
                    <dnn-tab tabTitle="Quick List">
                        {(this.memberInfo == undefined || this.memberInfo.ataNumber == null) &&
                            <p>Please login to see your scores.</p>
                        }
                        {this.memberInfo && this.memberInfo.ataNumber &&
                            <ata-sic-quick-list
                                moduleId={this.moduleId}
                                loggedIn={this.memberInfo != undefined && this.memberInfo.ataNumber != null}
                            />
                        }
                    </dnn-tab>
                    <dnn-tab tabTitle="All American">
                        <ata-sic-all-american
                            moduleId={this.moduleId}
                            loggedIn={this.memberInfo != undefined && this.memberInfo.ataNumber != null}
                        />
                    </dnn-tab>
                </dnn-tabs>
            </div>
        );
    }
}
